module.exports = __webpack_public_path__ + "static/media/defaultAppIcon.7939076e.png";